"use strict";

exports.__esModule = true;
exports.popoverTestUtils = void 0;

/** specific functions and variables for test environment purposes */
var popoverTestUtils = {
  createRange: function createRange() {
    document.createRange = function () {
      return {
        setStart: function setStart() {
          return null;
        },
        setEnd: function setEnd() {
          return null;
        },
        commonAncestorContainer: document.documentElement.querySelector('body')
      };
    };
  },
  generateId: function generateId() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
};
exports.popoverTestUtils = popoverTestUtils;
//# sourceMappingURL=helpers.js.map